// extracted by mini-css-extract-plugin
export default {"ScrollLock--enabled":"Q0v9bFNU46mzd2ECi6p_","ScrollLock--hiddenScrollBar":"BqUTYZ5JDn6ke9pgViA1"};